import {
  FETCHED_JOBS,
  START_FETCHING_JOBS,
  FETCHED_JOB,
  START_FETCHING_JOB,
} from '../actionTypes';

import { JobType } from '../../types/AppTypes';

interface InitialState {
  jobs: JobType[];
  loading: boolean;
  error: any;
  message: any;
  job: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  jobs: [],
  loading: false,
  error: null,
  message: null,
  job: null,
  tablePageSize: 10,
  currentPage: 1
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_JOBS:
      return {
        ...state,
        jobs: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_JOBS: {
      const { jobs, error, message } = action.payload;
      return {
        ...state,
        jobs,
        error,
        message,
        loading: false,
      };
    }
    case START_FETCHING_JOB:
      return {
        ...state,
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_JOB: {
      const { error, message } = action.payload;
      return {
        ...state,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
